import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "section section--mini screen-start faq" }

import "./FaqCategoryView.scss";
import faqs from "./../faqs";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import Question from "@/components/Question/Question.vue";
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqCategoryView',
  setup(__props) {

let route = useRoute();

let group = faqs[+route.params.group];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdditionalLayout, {
    title: `FAQ: ${_unref(group).title}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group).questions, (question, i) => {
          return (_openBlock(), _createBlock(Question, {
            title: question.question,
            class: "faq__item",
            key: i
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(question.answer), 1)
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})